export enum DIMENSION_TYPE {
  AE = 'AE',
  RP = 'RP',
  US = 'US',
  CD = 'CD',
  LS = 'LS',
  CI = 'CI',
  RE = 'RE',
  OS = 'OS',
}

export enum SYSTEM_SCORE {
  UPAF = 'UPAF',
  HKPFS = 'HKPFS',
}

export enum EVALUATION_PERMISSION_TYPE {
  EDIT = 'EDITABLE',
  VIEW = 'VIEW_ONLY',
  HIDE = 'HIDE',
}

export enum ACADEMIC_PROGRAMME_CATEGORY {
  ENGINEERING = 'Engineering',
  MEDICINE = 'Medicine',
  OTHERS = 'Others',
}

export enum EVALUATION_SCENE {
  NOMINATION = 'NOMINATION', // Supervisor View
  POLISH_COMMENTS = 'POLISH_COMMENTS', // Supervisor & Dorpg View
  INTERVIEW = 'INTERVIEW', // Interview Panel
  ENDORSEMENT = 'ENDORSEMENT', // Dorpg endorsement
  DORPG_PREVIEW = 'DORPG_PREVIEW', // Dorpg View without endorsement
  VIEW_ONLY = 'VIEW_ONLY', // Monitor for all roles
}
